import React, { useContext } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import CoreIcon from '@wix/da-ds/pkg/Icons/24x24/Core';
import EmptyState from '../../../EmptyState';
import { URLS } from '@wix/da-url/dist/src/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './SubscriptionsCoreOnlyBlock.scss';

export interface Props {
  className?: string;
  hasCore: boolean;
  createTier: () => void;
}

const SubscriptionsCoreOnlyBlock: React.FC<Props> = ({
  className,
  hasCore,
  createTier,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);

  let variant;
  let cta;
  // eslint-disable-next-line default-case
  switch (true) {
    case isMobile:
      variant = 'mobile';
      break;
    case hasCore:
      variant = 'hasCore';
      cta = (
        <SolidButton
          variant="approval-green"
          size="medium"
          priority="primary"
          onClick={createTier}
        >
          {t('page.subscriptions.coreOnlyBlock.CTAbutton.createTier')}
        </SolidButton>
      );
      break;
    case !hasCore:
      variant = 'noCore';
      cta = (
        <BrandedButton
          size="medium"
          variant="core-orange"
          href={URLS.CORE_MEMBERSHIP}
        >
          {t('page.subscriptions.coreOnlyBlock.CTAbutton.buyCore')}
        </BrandedButton>
      );
      break;
  }

  return (
    <EmptyState
      className={c(s['root'], className)}
      title={t(`page.subscriptions.coreOnlyBlock.title.${variant}`)}
      subtitle={
        <div className={s['subtitle-wrapper']}>
          <div className={s['subtitle']}>
            {t(`page.subscriptions.coreOnlyBlock.subtitle.${variant}`)}
          </div>
          <div className={s['subtitle-highlighted']}>
            <CoreIcon className={s['core-icon']} />
            {t(
              `page.subscriptions.coreOnlyBlock.subtitle.highlighted.${variant}`
            )}
          </div>
        </div>
      }
      illustration={<div className={s['illustration']} />}
      withIllustrationBelow
      customButton={cta}
    />
  );
};
SubscriptionsCoreOnlyBlock.displayName = 'SubscriptionsCoreOnlyBlock';

export default SubscriptionsCoreOnlyBlock;
